const state = {
    navToggled: false
}

const getters = {
    isNavToggled: state => state.navToggled
}

const actions = {

}

const mutations = {
    setNavToggled: (state, navToggled) => state.navToggled = navToggled
}

export default {
    state,
    getters,
    actions,
    mutations
}